'use client';

import { Libraries, useLoadScript } from '@react-google-maps/api';

import { Fluent } from '@/utils/environment';

const { GOOGLE_API_KEY } = Fluent.env;
const GOOGLE_MAPS_LIBRARIES: Libraries = ['geometry', 'drawing', 'places'];

interface Props {
  children: React.ReactNode;
}

const GoogleMapsLoader = ({ children }: Props) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  if (!isLoaded) return null;

  return children;
};

export { GoogleMapsLoader };
